import React from "react";
import { fetchDemoMode } from "../services/api";

/**
 * Is the demo-mode switch offered in THIS environment?
 *
 * The answer is the API's, not the browser's: `/v1/demo-mode` 404s whenever
 * ORBIT_ENV=prod, so a production console never learns the feature exists. The
 * result is cached at module scope because the sidebar renders on every route
 * change and the answer cannot change without a redeploy.
 */
let cached: boolean | null = null;
let inFlight: Promise<boolean> | null = null;

function probe(): Promise<boolean> {
  if (cached !== null) return Promise.resolve(cached);
  if (!inFlight) {
    inFlight = fetchDemoMode()
      .then(() => true)
      .catch(() => false)
      .then((ok) => { cached = ok; inFlight = null; return ok; });
  }
  return inFlight;
}

export function useDemoModeAvailable(): boolean {
  const [available, setAvailable] = React.useState<boolean>(cached ?? false);
  React.useEffect(() => {
    let alive = true;
    void probe().then((ok) => { if (alive) setAvailable(ok); });
    return () => { alive = false; };
  }, []);
  return available;
}
